<template>
  <div>
    <PageTitleVue
      :sub-title="'Gerencie todos os assinantes da plataforma'"
    >
      ASSINANTES
    </PageTitleVue>

    <ListAndForm />
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import AsosService from './service/asos.service'
// import TrainingsList from './layout/TrainingsList.vue'
import ListAndForm from './layout/BaseListAndFormAso.vue'
import { onBeforeMount } from 'vue'
import { storeApp } from '@/store'
import { dataAso } from './store'

const store = dataAso

onBeforeMount(async () => {
  storeApp.state.loading = true
  await getDocs()
  storeApp.state.loading = false
})

// pega todos os asos
async function getDocs () {
  await AsosService.getCustomers()
    .then(res => {
      console.log(res.data)
      store.dispatch('setAllDocs', res.data)
    }).catch(err => {
      console.log(err)
    })
}

</script>
